<template>
  <v-dialog v-model="dialogIsOpen" width="767px" max-height="559" min-height="400" persistent>
    <mf-loading loader-type="dialog" :boolean-loader="offerScheduleLoading || aggregatedClientCountByChannelLoading">
      <v-card>
        <v-card-title class="d-flex flex-column align-start">
          <h1 class="section-title">Comunicar</h1>
          <p class="subtitle" style="word-break: break-word">
            Por aqui você ainda pode iniciar uma nova campanha de comunicação apartir dessa gestão de ofertas. Dessa forma sua campanha já inicia com as mesmas
            informações, como nome, título, produtos, data de validade e público-alvo.
          </p>
          <h2 class="communicate-modal__campaign-title subtitle mt-2">A gestão de ofertas</h2>
          <p class="communicate-modal__campaign-name">
            {{ offerSchedule.name }} <span class="subtitle ml-2">{{ offerSchedule.description }}</span>
          </p>
        </v-card-title>
        <v-card-text>
          <h3 class="communicate-modal__channels-title subtitle mb-0">Pelo canal</h3>
          <v-radio-group v-model="channelSelected" row class="mt-0">
            <v-row>
              <v-tooltip
                v-for="(channel, channelIndex) in channelsOptions"
                :key="channelIndex"
                top
                :disabled="(channel.tooltipIsDisabled && channel.allowPersonalized) || (!channel.allowPersonalized && !hasSegments)"
                max-width="200"
              >
                <template v-slot:activator="{ on }">
                  <v-col :cols="channel.cols" :class="channel.columnAdditionalClass" v-on="on">
                    <v-radio color="primary" :value="channel.value" :disabled="channel.optionIsDisabled || (!channel.allowPersonalized && hasSegments)">
                      <template v-slot:label>
                        <p
                          class="communicate-modal__channel-name texto-corrido mb-0 d-flex flex-column"
                          :class="channel.optionIsDisabled || (!channel.allowPersonalized && hasSegments) ? 'communicate-modal__channel--disable' : ''"
                        >
                          {{ channel.label }}
                          <span
                            v-if="channel.clientsCount"
                            class="texto-corrido pt-2"
                            :class="channel.optionIsDisabled ? 'communicate-modal__channel--disable' : ''"
                          >
                            {{ abbreviation(channel.clientsCount.channel, { isInteger: true }) }} clientes - {{ channel.clientsCount.total }}% dos consumidores
                          </span>
                        </p>
                      </template>
                    </v-radio>
                  </v-col>
                </template>
                <span v-if="channel.optionIsDisabled"
                  >Você não tem acesso a esse canal. Para mais informações, consulte seu consultor Mercafacil ou o nosso suporte</span
                >
                <span v-else-if="!channel.allowPersonalized && hasSegments">Essa opção não está disponível para ofertas personalizadas.</span>
              </v-tooltip>
            </v-row>
          </v-radio-group>
          <mf-action-buttons
            :primary-button="{
              text: 'Comunicar por esse canal',
              action: communicateBySelectedChannel,
              isVisible: true,
              isDisabled: disableCommunicateByChannelButton,
            }"
            :extra-button="{
              text: 'Fechar',
              action: closeModal,
              isVisible: true,
            }"
          />
        </v-card-text>
      </v-card>
    </mf-loading>
  </v-dialog>
</template>

<script>
import { QUERY_SALES_CAMPAIGN_BY_ID } from '@/modules/campanhas/gestao-ofertas-v2/graphql'
import { QUERY_GET_AGGREGATE_CLIENT_COUNT_BY_CHANNEL } from '@/modules/campanhas/views/components/graphql'
import { getChannelsPermissionsStatus, checkIfSomeChannelIsAllowed } from '@/modules/campanhas/gestao-ofertas-v2/helpers/channels'
import { abbreviation, localeString } from '@/config/helpers.js'

export default {
  name: 'CommunicateModal',
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    offerScheduleId: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    offerSchedule: {},
    offerScheduleLoading: false,
    aggregatedClientCountByChannel: {
      sms: { total_count: 0 },
      email: { total_count: 0 },
      whatsapp: { total_count: 0 },
      push: { total_count: 0 },
      maria_campaign: { total_count: 0 },
      all: { total_count: 0 },
    },
    aggregatedClientCountByChannelLoading: false,
    channelSelected: '',
  }),
  computed: {
    dialogIsOpen: {
      get() {
        return this.value
      },
      set(newValue) {
        this.$emit('input', newValue)
      },
    },
    hasSegments() {
      return this.offerSchedule?.segments?.length > 0
    },
    disableCommunicateByChannelButton() {
      const existOfferSchedule = Object.entries(this.offerSchedule)?.length

      return !existOfferSchedule || !this.channelSelected
    },
    channelsPermissionsStatus() {
      return getChannelsPermissionsStatus(this.$permissions, this.$getAllowedModules)
    },
    isSomeChannelAllowed() {
      return checkIfSomeChannelIsAllowed(this.channelsPermissionsStatus)
    },
    channelsOptions() {
      const channels = [
        {
          cols: '6',
          columnAdditionalClass: ['mb-4'],
          value: 'SMS',
          label: 'SMS',
          allowPersonalized: true,
          optionIsDisabled: !this.channelsPermissionsStatus.sms,
          tooltipIsDisabled: this.channelsPermissionsStatus.sms,
          clientsCount: {
            channel: this.aggregatedClientCountByChannel.sms.total_count,
            total: this.getPercentageBaseClientsByChannel(this.aggregatedClientCountByChannel.sms.total_count),
          },
        },
        {
          cols: '6',
          columnAdditionalClass: ['mb-4'],
          value: 'MARIACAMPAIGN',
          label: 'Campanha da mar.ia',
          allowPersonalized: true,
          optionIsDisabled: !this.channelsPermissionsStatus.maria_campaign,
          tooltipIsDisabled: this.channelsPermissionsStatus.maria_campaign,
          clientsCount: {
            channel: this.aggregatedClientCountByChannel.maria_campaign.total_count,
            total: this.getPercentageBaseClientsByChannel(this.aggregatedClientCountByChannel.maria_campaign.total_count),
          },
        },
        {
          cols: '6',
          columnAdditionalClass: ['mb-4'],
          value: 'EMAIL',
          label: 'E-mail',
          allowPersonalized: true,
          optionIsDisabled: !this.channelsPermissionsStatus.email,
          tooltipIsDisabled: this.channelsPermissionsStatus.email,
          clientsCount: {
            channel: this.aggregatedClientCountByChannel.email.total_count,
            total: this.getPercentageBaseClientsByChannel(this.aggregatedClientCountByChannel.email.total_count),
          },
        },
        {
          cols: '6',
          columnAdditionalClass: [],
          value: 'PUSH',
          label: 'Push aplicativo',
          allowPersonalized: true,
          optionIsDisabled: !this.channelsPermissionsStatus.push,
          tooltipIsDisabled: this.channelsPermissionsStatus.push,
          clientsCount: {
            channel: this.aggregatedClientCountByChannel.push.total_count,
            total: this.getPercentageBaseClientsByChannel(this.aggregatedClientCountByChannel.push.total_count),
          },
        },
        {
          cols: '6',
          columnAdditionalClass: [],
          value: 'WHATSAPP',
          label: 'Whatsapp',
          allowPersonalized: true,
          optionIsDisabled: !this.channelsPermissionsStatus.whatsapp,
          tooltipIsDisabled: this.channelsPermissionsStatus.whatsapp,
          clientsCount: {
            channel: this.aggregatedClientCountByChannel.whatsapp.total_count,
            total: this.getPercentageBaseClientsByChannel(this.aggregatedClientCountByChannel.whatsapp.total_count),
          },
        },
        {
          cols: '6',
          columnAdditionalClass: [],
          value: 'HIGHLIGHT',
          label: 'Destaque',
          allowPersonalized: false,
          optionIsDisabled: !this.channelsPermissionsStatus.highlight,
          tooltipIsDisabled: this.channelsPermissionsStatus.highlight,
        },
        {
          cols: '6',
          columnAdditionalClass: [],
          value: 'BANNER',
          label: 'Banner',
          allowPersonalized: false,
          optionIsDisabled: !this.channelsPermissionsStatus.banner,
          tooltipIsDisabled: this.channelsPermissionsStatus.banner,
        },
      ]

      return channels
    },
    firstChannelOptionSelectedByDefault() {
      const channelsAllowed = this.channelsOptions.filter((channel) => !channel.optionIsDisabled)

      return channelsAllowed[0].value
    },
  },
  watch: {
    async dialogIsOpen(value) {
      if (value) {
        this.getOfferSchedule()
        this.getaggregatedClientCountByChannel()
      }
    },
  },
  mounted() {
    this.channelSelected = this.firstChannelOptionSelectedByDefault
  },
  methods: {
    abbreviation,
    closeModal() {
      this.offerSchedule = {}
      this.channelSelected = this.firstChannelOptionSelectedByDefault
      this.dialogIsOpen = false
    },
    async getOfferSchedule() {
      try {
        this.offerScheduleLoading = true
        const { data } = await this.$apollo.query({
          query: QUERY_SALES_CAMPAIGN_BY_ID,
          variables: {
            id: this.offerScheduleId,
          },
          context: {
            uri: this.$microservicesUrls['sales'],
          },
          fetchPolicy: 'no-cache',
        })
        this.offerSchedule = data.offerSchedule
      } catch (error) {
        console.error(error)
        this.$snackbar({ message: 'Erro ao buscar dados de uma oferta', snackbarColor: 'error' })
      } finally {
        this.offerScheduleLoading = false
      }
    },
    async getaggregatedClientCountByChannel() {
      try {
        this.aggregatedClientCountByChannelLoading = true
        const { data } = await this.$apollo.query({
          query: QUERY_GET_AGGREGATE_CLIENT_COUNT_BY_CHANNEL,
          fetchPolicy: 'no-cache',
        })
        this.aggregatedClientCountByChannel = data.getAggregatedClientStatusInfo
      } catch (error) {
        this.$snackbar({ message: 'Erro ao buscar dados de campanhas', snackbarColor: 'error' })
      } finally {
        this.aggregatedClientCountByChannelLoading = false
      }
    },
    getPercentageBaseClientsByChannel(channelClientsCount) {
      const percentageBaseClientsByChannel = (channelClientsCount / this.aggregatedClientCountByChannel.all.total_count) * 100 || 0
      return localeString(percentageBaseClientsByChannel, 2)
    },
    communicateBySelectedChannel() {
      const channelsRouteName = {
        SMS: 'campanhas-sms-cadastro',
        WHATSAPP: 'campanhas-whatsapp-cadastro',
        PUSH: 'campanhas-aplicativo-cadastro',
        EMAIL: 'campanhas-email-cadastro',
        MARIACAMPAIGN: 'new-maria-campaign',
        HIGHLIGHT: 'highlight-new',
        BANNER: 'banners-new',
      }
      this.$router.push({ name: channelsRouteName[this.channelSelected], params: { offerScheduleId: this.offerScheduleId } })
    },
  },
}
</script>

<style lang="scss" scoped>
.communicate-modal__campaign-title {
  font-weight: bold;
  color: $cinza-d10;
}

.communicate-modal__campaign-name {
  font-size: 22px;
  color: $cinza-d10;
}

.communicate-modal__channels-title {
  font-weight: bold;
  color: $cinza-d10;
}

.communicate-modal__channel-name {
  position: absolute;
  top: -4px;
  color: $cinza-d10;
}

.communicate-modal__channel--disable {
  color: #00000042;
}
</style>
